import { GoogleAnalytics } from '@next/third-parties/google';
import classNames from 'classnames';
import Head from 'next/head';
import React from 'react';

import { useIsMobile } from '@base/hooks/use-mobile';
import BuyImprvCoinsModal from '@components/imprvCoins/BuyImprvCoinsModal';
import { setupForDark } from '@theme';
import GoalSubscriptionStrategyFinishedModal from 'components/subscriptions/GoalSubscriptionStrategyFinishedModal';
import LayoutDesktop from './LayoutDesktop';
import LayoutMobile from './LayoutMobile';

export default function Layout({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile();

  const mainContent = (
    <main className={classNames(setupForDark('bg-page'), 'h-full overflow-y-auto')}>
      {children}
      <GoalSubscriptionStrategyFinishedModal />
      <BuyImprvCoinsModal />
    </main>
  );

  return (
    <>
      <Head>
        <title>IMPRV</title>
        <link rel='icon' href='/favicon.png' />
      </Head>
      <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_GA_ID} />
      {isMobile ? (
        <LayoutMobile>{mainContent}</LayoutMobile>
      ) : (
        <LayoutDesktop>{mainContent}</LayoutDesktop>
      )}
    </>
  );
}
